'use strict';
var KeyMirror = require('keymirror');

module.exports = {
    ActionTypes: KeyMirror({
        RECEIVE_ADVICE_FEE_LIST: null,
        ADD_ADVISER_FEE: null,
        GET_INVESTMENT_LIST: null,        
        GET_EXCESSIVE_FEE_CHECK_RESULT: null,
        REMOVE_SINGLE_RECORD: null,
        UPDATE_ADVICE_FEE: null
    }),

    ContextualHelpMessages: {
        USE_INVESTMENT_WEIGHTING: 'If you select ‘use investment weighting’, your advice fee will be deducted as per the investment weighting at time of deduction.',
        SELECT_OPTION: 'We establish a default order for deducting your advice fee, deducting from the most conservative option as determined by us.'
    },

    FeeTypes: {
        ASF: 'ASF',
        LSF: 'LSF'
    },

    Frequencies: {
        ONGOING: 'ongoing',
        ONEOFF: 'oneoff'
    },

    DeductionOptions: {
        INVESTMENT_WEIGHTING: 'InvstWeight',
        SELECT_OPTION: 'SelOption'
    },

    OngoingTypes: {
        AMT: 'amt',
        PER: 'per',
        BOTH: 'amtper'
    },

    DeductionQuestions: {
        DEDUCTION_OPTIONS_QUESTION: 'Select the investment option from which your advice fee is to be deducted ',
        DEDUCTION_SINGLE_OPTION_QUESTION: 'The Investment option from which your advice fees are to be deducted '
    },

    Labels: {
        NO_ADVISER_FEES: 'Adviser fees',
        ASF_ONGOING: 'Ongoing adviser service fee',
        ASF_ONEOFF: 'One-off adviser service fee',
        LSF_ONGOING: 'Ongoing licensee service fee',
        CPI: ' with yearly increase by a percentage based on CPI (or 3%, whichever is greater)',
        FEE_DEDUCTED_FROM: 'Fee deducted from',
        INVESTMENT_WEIGHTING_FEE_DEDUCTED: 'Fee deducted',
        INVESTMENT_WEIGHTING: 'As per investment weighting at time of deduction',
        INVESTMENT_WEIGHTING_FROM_SUPERFIRST: 'SuperFirst Transfer Facility'
    },

    AdviceFeeData: {
        adviceFeeOption: '',
        IsFeesExcessive: false,
        AdviceFeesList: [],
        IsReset: false
    },

    FeeTypesData: [
        { id: 'ASF', name: 'Adviser service fee', isHidden: false },
        { id: 'LSF', name: 'Licensee service fee', isHidden: false }
    ],

    FrequencyData: [
        { id: 'oneoff', name: 'One-off', isHidden: false, isDisabled: false },
        { id: 'ongoing', name: 'Ongoing', isHidden: false, isDisabled: false }
    ],

    OnGoingTyeData: [
        { id: 'amt', name: 'Amount', isHidden: false },
        { id: 'per', name: 'Percentage', isHidden: false },
        { id: 'amtper', name: 'Amount and percentage', isHidden: false }
    ],

    DeductionOptionData: [
    { id: 'InvstWeight', name: 'Use investment weighting', isHidden: false },
    { id: 'SelOption', name: 'Select option', isHidden: false }
    ],

    FieldNames: {
        ADD_ADVFEE_OPT: 'adviceFeeOption',
        FEE_TYPE: 'feeType',
        FREQUENCY: 'frequency',
        TRANS_FACILITY: 'transFacility',
        PEN_ACCOUNT: 'penAccount',
        FEE_AMOUNT: 'feeAmount',
        ADVICE_FEE_DE_OPT: 'adviceFeeDeductionOption',
        ONGOING_TYPE: 'onGoingType',
        ONGOING_MONTHLY_AMT: 'onGoingMonthlyAmount',
        ONGOING_PERCENTAGE: 'onGoingPercentage',
        IS_CPI: 'isCPI',
        INVESTMENT_ALLOCATION_ID: 'investmentAllocationId',
        ADD_ANOTHER_ADVISER: 'addAnotherAdviserFee'
    }
};


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./constants/AdviserFeeConstants.js